export const fetchLocalAuthInfo = () => {
  const authInfo = localStorage.getItem("auth")
  return authInfo ? JSON.parse(authInfo) : null
}

export const setLocalAuthInfo = auth => {
  return localStorage.setItem("auth", JSON.stringify(auth))
}

export const deleteLocalAuthInfo = () => {
  return localStorage.removeItem("auth")
}
